export class KeychainError extends Error {
    constructor(message, messageParams, stacktrace) {
        super(message);
        this.name = 'KeychainError';
        this.messageParams = messageParams;
        this.trace = stacktrace;
    }
}
